import { useCallback, useEffect, useMemo, useState } from 'react';
import { useMetadata } from '../../../../contexts/MetadataContext';
import { PropertyField } from '../../../../system/field';
import { ListingResource, useListingField } from '@brightmls/nextgen.lae.flc';
import { ResourceField } from '../../hooks/useResourceForm/useResourceForm';

export const useDefaultsForm = () => {
  const { template } = useMetadata();
  const [form, setForm] = useState<ResourceField[]>([]);

  // Subscribe to property type field
  const propertyTypeField = useListingField(
    ListingResource.Property,
    PropertyField.PROPERTY_TYPE,
    'Residential',
  );

  if (!propertyTypeField.value) {
    console.error('Property type is not set');
  }

  const templateForType = template(propertyTypeField.value);
  const groups = useMemo(
    () => templateForType?.groups || [],
    [templateForType],
  );

  const buildForm = useCallback(() => {
    const formBuilder: ResourceField[] = [];

    // load content here from fields with Allow Set Defaults checked
    groups.forEach((group) => {
      group.sections.forEach((section) => {
        section.fields.forEach((field) => {
          if (field.AllowSetFieldDefaults) {
            formBuilder.push({
              ...field,
            });
          }
        });
      });
    });

    // modify fields to style for this use case
    formBuilder.forEach((field) => {
      field.Layout = 'single';
      field.ForceRequired = false;
      field.SkipRequired = true;
    });
    // console.log('formBuilder', formBuilder);

    setForm(formBuilder);
  }, [groups]);

  useEffect(() => {
    buildForm();
  }, [groups, buildForm]);

  return {
    form,
  };
};
